import { render, staticRenderFns } from "./Tealium.vue?vue&type=template&id=091f1fd9&scoped=true"
import script from "./Tealium.vue?vue&type=script&lang=js"
export * from "./Tealium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091f1fd9",
  null
  
)

export default component.exports